export default {
	about_the: 'About the',
	company_agency: 'Platform you want to access:',
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files:
		'Explore todo o nosso universo de cursos, vídeos, artigos e arquivos.',
	project_name: 'Programa Inwictus',
	welcome_to: 'Welcome to',
}
